<template>
    <div class="auto-list form-control">
        <!-- optional indicators -->
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <template v-else>
            <i class="fa fa-search" v-show="isEmpty"></i>
            <i class="fa fa-times" v-show="isDirty" @click="reset"></i>
        </template>

        <!-- the input field -->
        <input name="domain" class="form-control popup-input" type="text" placeholder="Type in Domain" autocomplete="off" v-model="query" @keydown.down.prevent="down" @keydown.up.prevent="up" @keydown.enter="hit" @keydown.right="hit" @keydown.esc="reset" @blur="reset" @input="update"/>

        <!-- the list -->
        <ul v-show="hasItems">
            <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
                <span v-text="item"></span>
            </li>
        </ul>
    </div>
</template>

<script>
    import VueTypeahead from '../methods/vue-typeahead.js';
    export default {
        mixins: [VueTypeahead], // vue@1.0.21-

        data () {
            return {
                // Currently Selected
                selected: false,

                // The source url
                // (required)
                src: '/domain/list',

                // The data that would be sent by request
                // (optional)
                data: {},

                // Limit the number of items which is shown at the list
                // (optional)
                limit: 5,

                // The minimum character length needed before triggering
                // (optional)
                minChars: 3,

                // Highlight the first item in the list
                // (optional)
                selectFirst: false,

                // Override the default value (`q`) of query parameter name
                // Use a falsy value for RESTful query
                // (optional)
                queryParamName: 'search'
            }
        },

        methods: {
            update() {
                console.log('n/a');
            },
            reset () {
                this.items = [];
                this.loading = false;
            },

            // The callback function which is triggered when the user hits on an item
            // (required)
            onHit (item) {
                if (this.item && this.item != '') {
                    this.query = item;
                }
                this.reset();
            },
        }
    }
</script>
